import { InjectionToken } from '@angular/core';

export interface BacklogConfig {
  apiUrl: string;
}

export const BACKLOG_CONFIG = new InjectionToken<BacklogConfig>('BacklogConfig');
